
import TableList from "@components/templates/tablelist";
import { HttpListingList, HttpbatchSetVirtual, HttpbatchCreateProduct } from "@/service/setting";
import { mapGetters } from "vuex";
import comIndex from './update'
import compInventory from '../../products/allproducts/inventory'
// import mixin from './mixin'
export default {
    mixins: [TableList],
    components: {
        comIndex,
        compInventory
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_status: null
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: { show: true },

        };
    },
    // created(){
    // this.timehandle()
    // },
    methods: {
        ajaxRequest: HttpListingList,
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'settingtListingUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: "settingtListingUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "settingtListingUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "batchvirtual":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "设为虚拟",
                        width: 460,
                        showDesc: true,
                        desc: '虚拟产品或无需做对应关系的产品，可以设为虚拟。',
                        params: { ids: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpbatchSetVirtual
                    };
                    break;
                case "batchcreate":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "快速创建",
                        width: 460,
                        showDesc: true,
                        desc: '<div style="text-align: left;margin-left: 54px;color: #ed3f14;">1.快速创建时，ERP SKU默认和Seller SKU相同 </br>2.仅适用于简单产品 </br>3.FNSKU、ASIN、List Price、上架日期如有信息，会自动带到店铺产品的对应栏位</div>',
                        params: { ids: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpbatchCreateProduct
                    };
                    break;
                case 'exportQuery':
                    console.log(this.formData)
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/amazon_product_listing/exportXlsx", this.exportdata, {
                        download: true,
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                    break
                case 'inventory':
                    this.operate = {
                        title:this.$t("global.common.operation_see",{defaultValue:'查看'}),
                        show:true,
                        width:800,
                        showFooter:false,
                        component: "compInventory",
                        comperpsku:params,
                        querytype:'query',
                        typedata:'listinginventory'
                    }
                    // window.open(process.env.VUE_APP_FBB+'/home/inventory/list?erpsku='+data, '_blank');
                    break
            }
        },
        getOperateNodeMap (row) {
            const { id, isChannelRelate } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '设为虚拟',
                show: true,
                params: id,
                operate: 'batchvirtual'
            }, {
                label: '快速创建',
                show: isChannelRelate == 0,
                params: id,
                operate: 'batchcreate'
            },]
        },
        interceptRequest (params) {
            console.log(params)
            let search = params
            if (search.search.EQ_status === 1) {
                search.search.EQ_isChannelRelate = 0
                search.search.EQ_isVirtual = 0
            }
            console.log(search, 'searchsearchsearch')
            this.exportdata = search;
            return search
        }
    },
    computed: {
        ...mapGetters('diction', ['getProductList', 'getNewAccountList', 'getWarehouseList']),
        accountsTarget () {
            return this.getNewAccountList.map((item) => {
                // console.log(item)
                const bool = item.attach.status === 'inactive' && item.attach.type == "amazon";
                return {
                    label: bool ? `<span style='text-decoration:line-through'>${item.label}</span>` : `${item.label}`,
                    value: item.value,
                    // disabled:bool

                }
            })
        },
        TabsData () {
            return [
                {
                    name: "所有",
                    key: 'EQ_status',
                    val: null,
                }, {
                    name: "待创建店铺产品的Listing",
                    key: 'EQ_status',
                    val: 1,
                },
            ]
        },
        ToolsData () {
            return [
                // {
                //     name: "批量快速创建",
                //     operate: "batchcreate",
                //     batch: true,
                //     theme: 'primary'
                // },
                {
                    name: "查询条件导出",
                    operate: "exportQuery",
                    theme: 'success'
                }
            ]
        },
        SearchsData () {
            let stylewidth = "width:210px;"
            return [
                {
                    label: "SellerSKU",
                    tag: 'vInput',
                    key: 'CN_sellerSku',
                    show: true,
                },
                {
                    label: "ASIN",
                    tag: 'vInput',
                    key: 'CN_asin',
                    show: true,
                },
                {
                    label: "FNSKU",
                    tag: 'vInput',
                    key: 'CN_fnsku',
                    style: stylewidth,
                },
                {
                    label: "Manufacturer",
                    tag: 'vInput',
                    key: 'CN_manufacturer',
                    style: stylewidth,
                },

                {
                    label: "店铺名称",
                    tag: 'Select',
                    key: 'IN_channelFlag',
                    class:'minSelect',
                    options: this.accountsTarget.map(item => {
                        // console.log(item)
                        return {
                            value: item.value,
                            label: item.label
                        }
                    }),
                    hideSearchTip:true,
                    style: stylewidth,
                    props: {
                        clearable: true,
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: "标题",
                    tag: 'vInput',
                    key: 'EQ_title',
                    style: stylewidth,
                },
                {
                    label: "是否有店铺产品",
                    tag: 'Select',
                    options: [{ value: '1', label: '是' }, { value: '0', label: '否' }],
                    key: 'EQ_isChannelRelate',
                    style: stylewidth,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '是否虚拟',
                    tag: 'Select',
                    options: [{ value: '1', label: '是' }, { value: '0', label: '否' }],
                    key: 'EQ_isVirtual',
                    style: stylewidth,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '派送方式',
                    tag: 'Select',
                    options: [{ value: '1', label: 'AFN' }, { value: '0', label: 'MFN' }],
                    key: 'EQ_fulfillmentChannel',
                    style: stylewidth,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '上架日期',
                    tag: 'vDatepicker',
                    key: 'BT_openDate',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false
                    },
                    style: stylewidth,
                },
                {
                    label: '是否有效Listing',
                    tag: 'Select',
                    options: [{ value: '1', label: '是' }, { value: '0', label: '否' }],
                    key: 'EQ_status',
                    style: stylewidth,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '最新一次同步时间',
                    tag: 'vDatepicker',
                    key: 'BT_lastestSyncTime',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false
                    },
                    style: stylewidth,
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: stylewidth,
                },
            ]
        },
        columns() {
            return  [
            {
                show:false,
                type: 'selection',
                width: 60,
                align: 'center',
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes,
            },
            {
                title: '图片',
                width: 120,
                render:(h,{row})=>{
                    return <div style="float: left; cursor: pointer; margin-right: 10px;">
                        <img style="width: 100px; height: 100px;" src={row.imageLink}></img>
                    </div>
                }
            },
            {
                title: '店铺名称/国家',
                sortable: true,
                width: 160,
                render:(h,{row,index})=>{
                    //
                    return <div>
                        <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{this.findRenderLabel(this.getNewAccountList, row.channelFlag)}</a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-5 font-14" type="ios-browsers-outline" /></a>
                        <div>{row.country}</div>
                        </div>
                }
            },
            {
                title: '是否有店铺对应关系',
                width: 160,
                // key: 'sourceChannel',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.isChannelRelate == 0 ? '否' : '是'}</div>
                    </div>
                }
            },
            // ||
            {
                title: 'SellerSKU',
                width: 120 ,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.sellerSku} <Tooltip v-show={row.isVirtual==1} placement="top" content="virtual"><Icon type="ios-lock" /></Tooltip></div>
                    </div>
                }
            },
            {
                title: 'Title',
                width: 160 ,
                key:"title",
                sortable: true,
            },
            {
                title: 'ASIN',
                width: 120 ,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.asin}</div>
                    </div>
                }
            },
            {
                title: 'FNSKU',
                width: 160,
                render:(h,{row})=>{
                    return <div>{row.fnsku}</div>
                }
            },
            {
                title: 'List Price',
                width: 100 ,
                key:'listPrice',

            },

            {
                title: '上架日期',
                width: 120 ,
                key:"openDate",
                sortable: true,
            },
            {
                title: '派送方式',
                width: 100 ,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.fulfillmentChannel == 0 ? 'MFN' : row.fulfillmentChannel == 1 ? 'AFN' : '--'}</div>
                    </div>
                }

            },
            {
                title: '是否有效Listing',
                width: 140 ,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.status == 0 ? '否' : '是'}</div>
                    </div>
                }
            },
            {
                title: '排名',
                width: 120 ,
                key:"rank",
                sortable: true,
            },
            {
                title: 'Category',
                width: 120 ,
                key:"category",
                sortable: true,
            },
            {
                title: 'Manufacturer',
                width: 140 ,
                key:"manufacturer",
                sortable: true,
            },
            {
                title: 'Color',
                width: 120 ,
                key:"color",
                sortable: true,
            },
            // {
            //     title: '图片链接',
            //     width: 120 ,
            //     key:"imageLink",
            //     sortable: true,
            // },
            {
                title: 'FBA库存量',
                width: 120 ,
                key:"fbaInventory",
                sortable: true,
            },
            {
                title: '自发货仓库存量',
                width: 120 ,
                key:"inventoryQty",
                // sortable: true,
                render: (h, { row }) => {
                    return <div>
                        <div v-show={!row.erpsku}>{row.inventoryQty==0 ? row.inventoryQty: row.inventoryQty==null? '--' : row.inventoryQty}</div>
                        <div v-show={row.erpsku}><a onClick={this.handleOperates.bind(this, {erpsku:row.erpsku,qty:row.inventoryQty}, 'inventory')}>{row.inventoryQty==0 ? row.inventoryQty: row.inventoryQty==null? '--' : row.inventoryQty}</a></div>
                    </div>
                },
            },
            {
                title: '最近一次同步时间',
                width: 160 ,
                key:"lastestSyncTime",
                sortable: true,
            },

            {
                title: '更新时间',
                width: 160,
                key:'updatedAt'
            },
        ];
        },

    },

};
